(function () {
    'use strict';

    angular
        .module('app.login')
        .component('sc3ManageSettingsModal', {
            templateUrl: 'app/login/manage-settings-modal.component.html',
            bindings: { close: '&', dismiss: '&' },
            controller: ManageSettingsModalComponent
        });

    ManageSettingsModalComponent.$inject = ['user'];
    function ManageSettingsModalComponent(user) {
        var ctrl = this;
        ctrl.user = user;
    }
})();